import React from "react";
import NewProductTemplate from "../../components/sections/product-more-info/Item";
import { cn } from "../../utils/cn";
import Emoji from "../../utils/emoji";

const styles = {
    strong: "font-semibold text-ccyan",
    title: "font-bold text-xl font-montserrat",
    list: "list-disc ml-4",
};

const Product = (props) => {
    const { pageContext } = props;
    const { item } = pageContext;

    const Data = () => {
        return (
            <section className="mx-auto max-w-xl text-left font-inter text-gray-500 lg:max-w-2xl xl:max-w-3xl">
                <h2 className="text-2xl font-semibold text-cpurple">
                    <Emoji
                        symbol="🧠"
                        label="curs online psicotecnics aptitudinals 2026"
                    />{" "}
                    CURS ONLINE DE PSICOTÈCNICS APTITUDINALS — 12 HORES EN
                    DIRECTE – SETEMBRE I OCTUBRE 2026
                </h2>

                <p className="mt-5">
                    <strong>
                        Tècnica, velocitat i estratègia per arribar a
                        l&apos;examen amb més seguretat.
                    </strong>
                </p>

                <p className="mt-5">
                    Preparar els psicotècnics no consisteix només a fer
                    exercicis. Cal{" "}
                    <strong>
                        conèixer la tècnica, identificar ràpidament cada
                        tipologia, gestionar bé el temps i saber quina
                        estratègia aplicar
                    </strong>{" "}
                    en cada moment.
                </p>

                <p className="mt-5">
                    Per això, a iOpos hem preparat una formació intensiva de{" "}
                    <strong>
                        12 hores de psicotècnics aptitudinals en directe per
                        Zoom
                    </strong>
                    , distribuïdes en <strong>3 sessions de 4 hores</strong>, on
                    treballarem les principals àrees que et pots trobar a la
                    prova.
                </p>

                <p className="mt-5">
                    I no hauràs d&apos;esperar a la primera classe per començar:{" "}
                    <strong>
                        des del mateix moment de la matrícula tindràs accés al
                        Campus Online
                    </strong>{" "}
                    amb vídeos, exercicis i material complementari perquè puguis
                    avançar al teu ritme.
                </p>

                <h2 className={cn(styles.title, "mt-10")}>
                    <Emoji
                        symbol="🎯"
                        label="preparacio completa psicotecnics"
                    />{" "}
                    Una preparació completa i orientada a examen
                </h2>

                <p className="mt-5">
                    Durant les tres sessions combinarem explicació i pràctica
                    per ajudar-te a millorar progressivament el teu rendiment.
                </p>

                <p className="mt-5">
                    Treballarem especialment la{" "}
                    <strong>
                        tècnica de resolució, la velocitat, la precisió i la
                        gestió del temps
                    </strong>
                    , incidint en aquells trucs i estratègies que et poden
                    ajudar a resoldre els exercicis d&apos;una manera més
                    eficient.
                </p>

                <p className="mt-5">
                    L&apos;objectiu no és simplement practicar més, sinó{" "}
                    <strong>aprendre a resoldre millor</strong>.
                </p>

                <h2 className={cn(styles.title, "mt-10")}>
                    <Emoji symbol="🧠" label="que treballarem psicotecnics" />{" "}
                    Què treballarem?
                </h2>

                <p className="mt-5">
                    La formació abordarà les principals tipologies de
                    psicotècnics aptitudinals:
                </p>

                <ul className={cn(styles.list, "mt-5")}>
                    <li>
                        <strong>Raonament numèric.</strong>
                    </li>
                    <li>
                        <strong>Raonament espacial.</strong>
                    </li>
                    <li>
                        <strong>Raonament abstracte.</strong>
                    </li>
                    <li>
                        <strong>Raonament verbal.</strong>
                    </li>
                    <li>
                        <strong>Percepció i atenció.</strong>
                    </li>
                </ul>

                <p className="mt-5">
                    Cada bloc es treballarà amb explicacions, tècniques de
                    resolució i exercicis pràctics perquè puguis entendre el
                    procediment i aplicar-lo posteriorment pel teu compte.
                </p>

                <h2 className={cn(styles.title, "mt-10")}>
                    <Emoji symbol="💻" label="que inclou curs psicotecnics" />{" "}
                    Què inclou el curs?
                </h2>

                <p className="mt-5">
                    La formació combina{" "}
                    <strong>
                        Campus Online + classes en directe + pràctica +
                        simulacre
                    </strong>
                    , perquè tinguis una preparació completa durant les setmanes
                    prèvies a l&apos;examen.
                </p>

                <p className="mt-5">Tindràs:</p>

                <ul className={cn(styles.list, "mt-5")}>
                    <li>
                        <strong>
                            12 hores de formació en directe via Zoom
                        </strong>
                        , distribuïdes en 3 sessions.
                    </li>
                    <li>
                        Accés immediat al <strong>Campus Online</strong> des del
                        moment de la matrícula.
                    </li>
                    <li>
                        Vídeos explicatius amb{" "}
                        <strong>tècniques i mètodes de resolució</strong>.
                    </li>
                    <li>Exercicis per practicar les diferents tipologies.</li>
                    <li>
                        Trucs i estratègies per{" "}
                        <strong>guanyar velocitat i precisió</strong>.
                    </li>
                    <li>
                        Resolució d&apos;exercicis i dubtes durant les classes.
                    </li>
                    <li>
                        <strong>Gravació de totes les sessions</strong> per
                        poder tornar-les a veure.
                    </li>
                    <li>Repàs general abans de l&apos;examen.</li>
                    <li>
                        <strong>
                            Simulacre final en temps real d&apos;examen
                        </strong>
                        , amb correcció i explicació detallada.
                    </li>
                </ul>

                <h2 className={cn(styles.title, "mt-10")}>
                    <Emoji symbol="📅" label="calendari classes psicotecnics" />{" "}
                    Calendari de classes
                </h2>

                <h2 className={cn(styles.title, "mt-10")}>
                    <Emoji
                        symbol="🔢"
                        label="sessio raonament numeric espacial"
                    />{" "}
                    Sessió 1 — Raonament numèric i espacial
                </h2>

                <ul className={cn(styles.list, "mt-5")}>
                    <li>
                        <strong>Dimecres 30 de setembre de 2026</strong>
                    </li>
                    <li>
                        <strong>De 16.00 a 20.00 h</strong>
                    </li>
                </ul>

                <p className="mt-5">
                    Treballarem tècniques i estratègies específiques per
                    afrontar els exercicis de{" "}
                    <strong>raonament numèric i espacial</strong> amb més
                    agilitat.
                </p>

                <h2 className={cn(styles.title, "mt-10")}>
                    <Emoji
                        symbol="🧩"
                        label="sessio raonament abstracte verbal"
                    />{" "}
                    Sessió 2 — Raonament abstracte i verbal
                </h2>

                <ul className={cn(styles.list, "mt-5")}>
                    <li>
                        <strong>Dimecres 7 d&apos;octubre de 2026</strong>
                    </li>
                    <li>
                        <strong>De 16.00 a 20.00 h</strong>
                    </li>
                </ul>

                <p className="mt-5">
                    Una sessió centrada en la{" "}
                    <strong>
                        identificació de patrons i relacions lògiques
                    </strong>
                    , així com en exercicis de raonament abstracte i verbal.
                </p>

                <h2 className={cn(styles.title, "mt-10")}>
                    <Emoji
                        symbol="👁️"
                        label="sessio percepcio atencio simulacre"
                    />{" "}
                    Sessió 3 — Percepció i atenció + simulacre final
                </h2>

                <ul className={cn(styles.list, "mt-5")}>
                    <li>
                        <strong>Dimecres 14 d&apos;octubre de 2026</strong>
                    </li>
                    <li>
                        <strong>De 16.00 a 20.00 h</strong>
                    </li>
                </ul>

                <p className="mt-5">
                    Treballarem percepció i atenció i dedicarem la part final de
                    la formació a fer un{" "}
                    <strong>
                        repàs general i un simulacre en condicions reals de
                        temps
                    </strong>
                    .
                </p>

                <p className="mt-5">
                    Un cop finalitzat, es realitzarà la{" "}
                    <strong>
                        correcció i explicació detallada dels exercicis
                    </strong>
                    , perquè puguis detectar errors i acabar de reforçar els
                    punts que més necessitis.
                </p>

                <h2 className={cn(styles.title, "mt-10")}>
                    <Emoji
                        symbol="🚀"
                        label="acces immediat campus psicotecnics"
                    />{" "}
                    Comença des del moment de la matrícula
                </h2>

                <p className="mt-5">
                    <strong>
                        No has d&apos;esperar fins al 30 de setembre per
                        començar a preparar-te.
                    </strong>
                </p>

                <p className="mt-5">
                    <strong>
                        Des del moment en què adquireixis el curs tindràs accés
                        immediat al Campus Online
                    </strong>
                    , on trobaràs vídeos explicatius, exercicis i material
                    específic perquè puguis començar a treballar abans de les
                    sessions en directe.
                </p>

                <p className="mt-5">
                    D&apos;aquesta manera, podràs{" "}
                    <strong>
                        avançar al teu ritme, arribar a les classes amb una base
                        prèvia i aprofitar encara més les explicacions dels
                        docents
                    </strong>
                    .
                </p>

                <h2 className={cn(styles.title, "mt-10")}>
                    <Emoji
                        symbol="🎥"
                        label="classes directe gravacions psicotecnics"
                    />{" "}
                    Classes en directe + gravacions
                </h2>

                <p className="mt-5">
                    Les tres sessions es realitzaran{" "}
                    <strong>100% online i en directe a través de Zoom</strong>.
                </p>

                <p className="mt-5">
                    A més, totes les classes quedaran gravades i disponibles al
                    campus <strong>fins al 17 d&apos;octubre de 2026</strong>,
                    perquè puguis tornar a veure les explicacions, repetir
                    exercicis i reforçar els blocs que més et costin abans de
                    l&apos;examen.
                </p>

                <h2 className={cn(styles.title, "mt-10")}>
                    <Emoji symbol="💰" label="preu curs psicotecnics" /> Preu
                </h2>

                <p className="mt-5">
                    <strong>99,99 €</strong>
                </p>

                <h2 className={cn(styles.title, "mt-10")}>
                    <Emoji symbol="🎯" label="resum curs psicotecnics" /> En
                    resum
                </h2>

                <p className="mt-5">
                    Una preparació intensiva que combina{" "}
                    <strong>
                        Campus Online + 12 hores de classes en directe +
                        tècniques i estratègies + exercicis pràctics + simulacre
                        final
                    </strong>
                    .
                </p>

                <p className="mt-5">
                    Tres sessions per treballar les principals tipologies de
                    psicotècnics aptitudinals i aprendre no només a resoldre els
                    exercicis, sinó a fer-ho{" "}
                    <strong>amb més velocitat, precisió i estratègia</strong>.
                </p>

                <p className="mt-5">
                    <Emoji symbol="👉" label="preparacio examen psicotecnics" />{" "}
                    <strong>
                        Comença a preparar-te des del moment de la matrícula i
                        arriba a l&apos;examen sabent com gestionar cada
                        exercici i cada minut de la prova.
                    </strong>
                </p>
            </section>
        );
    };

    return (
        <NewProductTemplate
            item={item}
            title="La prova és a prop. Ara no es tracta d’estudiar més, sinó de saber resoldre millor."
        >
            <Data />
        </NewProductTemplate>
    );
};

export default Product;
